// eslint-disable-next-line
import util from 'util';

import React, { Component } from 'react';
import { connect } from 'react-redux';

// eslint-disable-next-line
import * as MuiCore from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

// import * as ServiceIcons from './Icons';

import * as coreSelectors from '../core/selectors';
import * as serviceSelectors from './selectors';
import * as serviceActions from './actions';
import Activity from './Activity';
import MinutesUsed from '../account/MinutesUsed';
import RubyStatus from './RubyStatus';
import { canAccessChatActivity } from 'utils';
import ChatActivity from './ChatActivity';
import {withRouter} from 'react-router-dom'
import { USER_ACCOUNT_ROLE_KEYS } from 'constants/account.roles.constants';
// import OpenInvoices from '../account/OpenInvoices';

// import classnames from 'classnames';
// const drawerWidth = 90;

const styles = theme => ({
  /* Around the content.  Not raised in this page like the 
     others as the individual are raise */
  contentBox: {
    position: 'relative',
    width: '100%',
    height: '100%',
  },

  /* Left side full height panel */
  activityPanel: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: '50%',
    bottom: 0,
    marginRight: 10,
    borderRadius: 20,
    padding: 0,
  },

  /* Right side area that's several stacked boxes */
  rightSide: {
    position: 'absolute',
    top: 0,
    left: '50%',
    right: 0,
    bottom: 0,
    display: 'flex',
    flexDirection: 'column',
    marginLeft: 10,
  },

  verticalLine:{
    height: '100%',
    width: 1,
    backgroundColor: '#909090',
  },

  /* Top block on the right side with the block all calls option */
  handlingPanel: {
    // borderRadius: '20px 100px 100px 20px',
    padding: 10,
    display: 'flex',
    flex:1,
    marginBottom:20,
    border:'1px solid #cccdd2',
    alignItems: 'center',
  },

  /* Large agent icon on left side of hold calls area */
  agentIcon: {
    width: 110,
    height: 110,
    padding: 10,
  },

  /* Taking calls text in the handling panel */
  takingCalls: {
    flex:3,
    fontFamily:'Sofia W01 Regular1446825,sans-serif'
  },

  currentStatus:{
    flex:2,
    justifyContent:'center',
    fontFamily:'Sofia'
  },

  /* Large icon button in taking calls panel  */
  holdCallsButton: {
    height: 140,
    width: 140,
    '& svg': {
      width: 40,
      height: 40,
      marginBottom: 5,
    },
    '& div': {
      ...theme.typography.caption,
      lineHeight: '110%',
    },
  },
  holdingBackground:{
    background:'grey'
  },

  /* Middle panel for current usage */
  minutesUsedPanel: {
    // borderRadius: 20,
    flexBasis: 1,
    flexGrow: 1,
    // marginTop: 20,
    marginRight:20,
    padding: 20,
    display: 'flex',
    //alignItems: 'center',
    justifyContent: 'center',
    ...theme.typography.h6,
    textAlign: 'center',
    border:'1px solid #cccdd2',
  },

  weeklyInsightsPanel: {
    // borderRadius: 20,
    flexBasis: 1,
    flexGrow: 1,
    // marginTop: 20,
    marginRight:20,
    padding: 20,
    //alignItems: 'center',
    border:'1px solid #cccdd2',
  },

  /* Bottom panel for billing */
  billingPanel: {
    borderRadius: 20,
    flexGrow: 1,
    flexBasis: 1,
    marginTop: 20,
    padding: 30,
    display: 'flex',
    //alignItems: 'center',
    justifyContent: 'center',
    ...theme.typography.h6,
    textAlign: 'center',
  },

  /* Stubbed in filler logo */
  deniedLogo: {
    height: '100%',
  },

  flexContainer:{

      minHeight: '100%',
      display: 'flex',
      flexDirection: "column",
    },
    flexItemRoot: {
      // these are flex items
      
      // flex: 1; same as:
      flexGrow: 0,
      // flex-shrink: 1;
      // flex-basis: auto;
      // flex: 1 1 auto;
      flex: 1,
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
    },
    flexItem: {
      // also flex items 
      flex: 1,
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
    },
    statusIcons:{
      display:'flex',
      flexDirection:'row',
      marginTop:20
    },
    recentActivityContainer: {
      // borderRadius: '20px 100px 100px 20px',
      padding: 10,
      // display: 'flex',
      // flexDirection:'column',
      // flex:1,
      marginBottom:20,
      border:'1px solid #cccdd2',
      alignItems: 'flex-start',
    },
    recentAcitvityTitleContainer: {
      display: "flex",
      justifyContent: "space-between",
      padding: "10px 20px 0 20px",
    },
    title: {
      ...theme.typography.h6,
      fontFamily: "Sofia-bold",
    },
    link : {
      fontFamily: "Sofia-bold",
      cursor: "pointer",
      color: "#09122B",
      fontWeight: 400,
      fontSize: 14,
      textDecoration: "underline",
      "& :hover": {
        color: "#E5196C",
      },
      "& svg": {
        margin: "0 5px",
      },
      "& span": {
        margin: "0 2px",
      },
    }
  });


/*
 * Default filler screen until the real one is implemented
 */

class Dashboard extends Component {

  componentDidMount(){
    document.title = 'Ruby - Dashboard'
  }

  state = {
    selectedTab:0
  }

  getNextDayOfWeek(date, dayOfWeek) {
    var resultDate = new Date(date.getTime());
    resultDate.setDate(date.getDate() + (7 + dayOfWeek - date.getDay()) % 7);
    return resultDate;
  }

  // If any one of the accounts have GLOBALADMIN then show billing and insights
  // if not hide them
  checkUserRoles = () => {
    var userRoles = this.props.user.userAccountRoles.filter(account => account.userRoleKey === 'USER' || account.userRoleKey === 'USERSMS' || account.userRoleKey === 'USEROUTCALL' || account.userRoleKey.includes('GRASSHOPPER')).length || 0;
    return userRoles > 0;
  }

  getWeeklyInsightsDate(){
    // const t = new Date().getDate() + (6 - new Date().getDay() - 1) - 7 ;
    const startDate = new Date(new Date().getTime() - (7*24*60*60*1000)).toLocaleString('default', {month: 'short', day: 'numeric'});
    const endDate = new Date().toLocaleString('default', {month: 'short', day: 'numeric'});
    if(startDate.split(" ")[0] === endDate.split(" ")[0]){
      return `${startDate} - ${endDate.split(" ")[1]}`;
    }
    return startDate + " - " + endDate;
  }

  checkParentAccount = () => {
    return this.props.user.userAccountRoles.filter(account => account.parentAccountId !== undefined).length > 1;
  }

  checkParentAccount = () => {
    return this.props.user.userAccountRoles.filter(account => account.parentAccountId !== undefined).length > 1;
  }

  checkPartner = () => {
    return (this.props.user.userAccountRoles.filter(role => role.userRoleKey === USER_ACCOUNT_ROLE_KEYS.PARTNERS).length > 0 || 
    this.props.user.userAccountRoles.filter(role => role.userRoleKey === USER_ACCOUNT_ROLE_KEYS.GRASSHOPPER).length > 0 || 
    this.props.user.userAccountRoles.filter(role => role.userRoleKey === USER_ACCOUNT_ROLE_KEYS.GRASSHOPPERSMS).length > 0);
  }

  checkChatServiceEnabled = () => {
    return canAccessChatActivity(this.props.user)
  }
  handleTabChange = (e,num)=>{
    this.setState({selectedTab:num})
  }
  render() {
    const { classes, last20Messages, user } = this.props;

    let newChatLeads = last20Messages?.userMessages?.filter(item => item.messageType === 'CHAT' && new Date(item.taken) > new Date().getTime() - (7*24*60*60*1000)).filter(item => item.types === 'Lead').length;
    let newLeads = user.leadCount;
    let currentClient = user.currentClientCount;

    return (
      <React.Fragment>
        <MuiCore.Grid container style={{height:'100%'}}>
          <MuiCore.Grid item xs={12} md={this.checkPartner() ? 12: 8}>
            <MuiCore.Grid item xs={12} className={classes.flexItemRoot} style={{flexGrow:0}}>
                <div className={classes.handlingPanel} style={{margin: 5}}>
                  <RubyStatus dashboard={true}/>
                    {/* <MuiCore.Grid item style={{width: '100%', textAlign: 'center', flexDirection: 'row', display: 'flex', justifyContent: 'center'}}>
                        <MuiCore.Grid style={{textAlign: 'left', height: 100}}>
                            <MuiCore.Typography variant='h5' style={{fontSize:22,fontFamily:'Sofia-bold',textAlign:'center',marginTop:20, textDecoration:'underline', textDecorationColor: '#F9E7BD', textDecorationThickness: 8}}>
                                My Current Status
                            </MuiCore.Typography>
                            <div style={{flexDirection:'row',display:'flex',justifyContent:'center',fontFamily:'Sofia-bold'}}>
                                <div className={classes.statusIcons}>
                                <ServiceIcons.EditIcon style={{marginTop: 2}} />
                                <MuiCore.Typography variant='body2' style={{fontFamily:'Sofia-bold', marginLeft: 2, fontSize: '16px'}}>Update</MuiCore.Typography>
                                </div>
                                <div className={classes.statusIcons}>
                                <ServiceIcons.CancelIcon style={{marginTop: 2, marginLeft: 10}} />
                                <MuiCore.Typography variant='body2' style={{fontFamily:'Sofia-bold', marginLeft: 2, fontSize: '16px'}}>Clear</MuiCore.Typography>
                                </div>
                            </div>
                        </MuiCore.Grid>
                        <MuiCore.Divider orientation='vertical' variant='middle' style={{height: 90, marginTop: 20, marginLeft: 50, marginRight: 50}}></MuiCore.Divider>
                        <MuiCore.Grid style={{textAlign: 'left', height: 100}}>
                            <MuiCore.Typography style={{fontSize:18,fontFamily:'Sofia-bold',marginTop:20}}>
                                Not taking calls
                            </MuiCore.Typography>
                            <MuiCore.Typography style={{fontSize:16,fontFamily:'Sofia-bold',marginTop:2, color: '#858DA3'}}>
                                Today, Jan 19, 9:33 am - Until further notice
                            </MuiCore.Typography>
                            <MuiCore.Typography style={{fontSize:16,fontFamily:'Sofia',marginTop:4}}>
                                We'll hold your calls.
                            </MuiCore.Typography>
                        </MuiCore.Grid>
                    </MuiCore.Grid> */}
                  {/* <MuiCore.Button
                    onClick={toggleHoldCalls}
                    className={classnames(classes.holdCallsButton,
                      { [classes.holdingBackground]: user.holdCalls === 'Y' })} >
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>

                      <MuiCore.Hidden xlDown={user.holdCalls === 'Y'}>
                        <MuiCore.Typography variant='subtitle1' style={{fontWeight:800}}>Accepting Transfers</MuiCore.Typography>
                      </MuiCore.Hidden>
                      <MuiCore.Hidden xlDown={user.holdCalls !== 'Y'}>
                        <MuiCore.Typography variant='subtitle1'  style={{fontWeight:800}}>Not Accepting Transfers</MuiCore.Typography>
                      </MuiCore.Hidden>
                    </div>
                  </MuiCore.Button> */}
                </div>
              </MuiCore.Grid>
            <div className={classes.recentActivityContainer} style={{ margin: 5 }}>
                {this.checkChatServiceEnabled() && <MuiCore.Tabs
                  value={this.state.selectedTab}
                  onChange={this.handleTabChange}
                >
                  <MuiCore.Tab
                    label="Recent Activity"
                    style={{ textTransform: "none", fontFamily:'Sofia-bold', fontSize: '16px' }}
                  />
                  <MuiCore.Tab
                    label="Recent Chats"
                    style={{ textTransform: "none", fontFamily:'Sofia-bold', fontSize: '16px' }}
                  />
                </MuiCore.Tabs>}
                {this.state.selectedTab === 0 ? (
                  <>
                    <div className={classes.recentAcitvityTitleContainer}>
                      <MuiCore.Typography className={classes.title}>
                        {!this.checkChatServiceEnabled() && "Recent Activity"}
                      </MuiCore.Typography>
                      <MuiCore.Typography
                        onClick={() => this.props.history.push("/activity")}
                        className={classes.link}
                      >
                        See all activity
                      </MuiCore.Typography>
                    </div>
                    <Activity dashboard />
                  </>
                ) : (
                  <>
                    <div className={classes.recentAcitvityTitleContainer}>
                      <MuiCore.Typography className={classes.title}>
                      {!this.checkChatServiceEnabled() && "Recent Chats"}
                      </MuiCore.Typography>
                      <MuiCore.Typography
                        onClick={() =>
                          this.props.history.push("/chat-activity")
                        }
                        className={classes.link}
                      >
                        See all chats
                      </MuiCore.Typography>
                    </div>
                    <ChatActivity dashboard />
                  </>
                )}
            </div>
          </MuiCore.Grid>
         {!this.checkPartner() && <MuiCore.Grid item xs={12} md={4}>
            <MuiCore.Grid container className={classes.flexContainer}>
             <MuiCore.Grid item xs={12} className={classes.flexItemRoot}>
                <div className={classes.weeklyInsightsPanel} style={{margin: 5, marginRight: 25}}>
                  <MuiCore.Grid style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
                    <MuiCore.Typography style={{fontFamily: 'Sofia', fontSize: 18, fontWeight: 700}}>
                      Weekly Insights
                    </MuiCore.Typography>
                    <MuiCore.Typography style={{fontFamily: 'Sofia', fontSize: 14, fontWeight: 700, color: '#858DA3'}}>
                      {this.getWeeklyInsightsDate()}
                    </MuiCore.Typography>
                  </MuiCore.Grid>
                  <MuiCore.Grid style={{marginTop: 10, marginLeft: 20}}>
                    <MuiCore.Typography>
                      <span style={{fontFamily: 'Sofia-bold', fontSize: 34, marginRight: 10}}>{newLeads}</span>
                      <span style={{fontFamily: 'Sofia', fontSize: 18}}>New call leads</span>
                    </MuiCore.Typography>
                    {this.checkChatServiceEnabled() && <MuiCore.Typography>
                      <span style={{fontFamily: 'Sofia-bold', fontSize: 34, marginRight: 10}}>{newChatLeads}</span>
                      <span style={{fontFamily: 'Sofia', fontSize: 18}}>New chat leads</span>
                    </MuiCore.Typography>}
                    <MuiCore.Typography>
                      <span style={{fontFamily: 'Sofia-bold', fontSize: 34, marginRight: 10}}>{currentClient}</span>
                      <span style={{fontFamily: 'Sofia', fontSize: 18}}>Current client</span>
                    </MuiCore.Typography>
                  </MuiCore.Grid>
                </div>
              </MuiCore.Grid>
              {<MuiCore.Grid item xs={12} className={classes.flexItemRoot} style={{marginTop: 20, margin: 5}}>
                <div style={{marginRight: 20}}>
                  <MinutesUsed />
                </div>
              </MuiCore.Grid>}
              {/* <MuiCore.Grid item xs={12} className={classes.flexItemRoot}>
                <MuiCore.Paper className={classes.billingPanel}>
                  <OpenInvoices />
                </MuiCore.Paper>
              </MuiCore.Grid> */}
            </MuiCore.Grid>
          </MuiCore.Grid>}
        </MuiCore.Grid>
        {/* <div className={classes.contentBox}>
          <div className={classes.activityPanel}>
            <Activity dashboard={true} />
          </div>
          <div className={classes.rightSide}>
            <MuiCore.Paper className={classes.handlingPanel}>
              <ServiceIcons.AgentIcon  className={classes.agentIcon}/>
              <div className={classes.takingCalls}>
                <MuiCore.Hidden xlDown={user.holdCalls === 'Y'}>
                  <MuiCore.Typography variant='h5'>Taking Calls</MuiCore.Typography>
                  <MuiCore.Typography variant='body2'>My normal call-handling</MuiCore.Typography>
                </MuiCore.Hidden>
                <MuiCore.Hidden xlDown={user.holdCalls !== 'Y'}>
                  <MuiCore.Typography variant='h5'>Holding Calls</MuiCore.Typography>
                  <MuiCore.Typography variant='body2'>Hold all my calls</MuiCore.Typography>
                </MuiCore.Hidden>
              </div>
              <MuiCore.Button
                onClick={toggleHoldCalls}
                className={classnames(classes.holdCallsButton, 
                                      { [classes.holdingBackground]: user.holdCalls === 'Y'})} >
                <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>

                  <MuiCore.Hidden xlDown={user.holdCalls === 'Y'}>
                    <ServiceIcons.HoldCallsIcon/>                    
                    <div>Hold My</div>
                    <div>Calls</div>
                  </MuiCore.Hidden>
                  <MuiCore.Hidden xlDown={user.holdCalls !== 'Y'}>
                    <ServiceIcons.TakeCallsIcon/>                    
                    <div>Clear Call</div>
                    <div>Hold</div>
                  </MuiCore.Hidden>
                </div>
              </MuiCore.Button>
            </MuiCore.Paper>
            <MuiCore.Paper className={classes.minutesUsedPanel}>
              <MinutesUsed/>
            </MuiCore.Paper>
            <MuiCore.Paper className={classes.billingPanel}>
              <OpenInvoices/>
            </MuiCore.Paper>
          </div>
        </div> */}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return ({
    user: coreSelectors.getUser(state),
    last20Messages: serviceSelectors.getLast20Messages(state),
  });
};

const mapDispatchToProps = {
  toggleHoldCalls: serviceActions.toggleHoldCalls,
  setActivityViewType: serviceActions.setActivityViewType
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Dashboard)));

